import DOMPurify from 'dompurify';
import MarkdownIt from 'markdown-it/dist/markdown-it';

const markdownRenderer = new MarkdownIt({
    html: false,
    linkify: false,
    breaks: true,
});

markdownRenderer.disable(['image', 'table', 'link', 'autolink']);

const allowedTags = [
    'blockquote',
    'br',
    'code',
    'em',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'li',
    'ol',
    'p',
    'pre',
    'strong',
    'ul',
];

export default function renderChatbotMarkdown(text) {
    return DOMPurify.sanitize(markdownRenderer.render(text || ''), {
        ALLOWED_TAGS: allowedTags,
        ALLOWED_ATTR: [],
    });
}
